import { Stack } from '@mui/material';
import React from 'react';
import Receiption from '../Receiption/Receiption';

const Receiptions = ({
  receiptions,
  setReceptions,
  details,
}) => {
  return (
    <React.Fragment>
      <Stack gap="1em">
        {receiptions?.map((receiption) => (
          <Receiption
            receiption={receiption}
            key={receiption?.Id}
            setReceptions={setReceptions}
            details={details}
          />
        ))}
      </Stack>
    </React.Fragment>
  );
};

export default Receiptions;
